import gql from 'graphql-tag';

const GET_AGGRGATED_VALUES = gql`
  query($input: GetAggregatedValuesInput!) {
    getAggregatedValues(input: $input) {
      data
      hasMore
    }
  }
`;

const GET_WORKLOG_SEGMENT = gql`
  query($input: ListInfoInput) {
    getWorklogSegmentList(input: $input) {
      segments {
        segmentId
        event {
          startTime
          endTime
        }
        timespent
        item {
          itemId
          notes
          afterHours
          billable
          status
          worklogTimerType
          serviceItem {
            itemId
            name
          }
          workItem {
            workId
            module
            client {
              accountId
              name
            }
            ticket {
              ticketId
              subject
              client {
                accountId
                name
              }
            }
            project {
              projectId
              title
            }
          }
        }
      }
      listInfo {
        page
        pageSize
        sort {
          attribute
          order
        }
        condition
        totalCount
        hasMore
      }
    }
  }
`;

const GET_CALENDAR_EVENTS = gql`
  query($input: ListInfoInput) {
    getCalendarEvents(input: $input) {
      events {
        eventId
        eventType
        startTime
        endTime
        worklogSegment {
          segmentId
          timespent
          item {
            itemId
            afterHours
            status
            workItem {
              workId
              module
              ticket {
                ticketId
                subject
              }
              project {
                projectId
                title
              }
              client {
                accountId
                name
              }
            }
            technician {
              userId
            }
          }
        }
      }
      listInfo {
        page
        pageSize
        sort {
          attribute
          order
        }
        condition
        totalCount
        hasMore
      }
    }
  }
`;

export { GET_AGGRGATED_VALUES, GET_WORKLOG_SEGMENT, GET_CALENDAR_EVENTS };
